/* ==========================================================================
   CoZzzy — nouvelle page d'accueil : défilements, îlot, barre produit,
   arches (pastilles de couleur), vidéos et apparitions.
   ========================================================================== */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = docEl.classList.contains('shopify-design-mode') || !!(window.Shopify && window.Shopify.designMode);

  /* Sur ordinateur, le thème fait défiler .page-wrapper au lieu de la fenêtre. */
  function pageWrapper() { return document.querySelector('.page-wrapper'); }
  function scrollTop() {
    var pw = pageWrapper();
    return Math.max(window.scrollY || window.pageYOffset || 0, pw ? pw.scrollTop : 0);
  }

  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  /* ------------------------------------------------------------------------
     Défilement infini
     ------------------------------------------------------------------------ */
  function setupMarquee(el) {
    var track = el.querySelector('[data-czh-track]');
    var group = track && track.querySelector('[data-czh-group]');
    if (!track || !group) return;

    track.querySelectorAll('[data-czh-clone]').forEach(function (n) { n.remove(); });
    var width = group.getBoundingClientRect().width;
    if (!width) return;

    var copies = Math.max(1, Math.ceil((el.clientWidth + width) / width));
    for (var i = 0; i < copies; i++) {
      var clone = group.cloneNode(true);
      clone.removeAttribute('data-czh-group');
      clone.setAttribute('data-czh-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
      track.appendChild(clone);
    }

    var speed = parseFloat(el.getAttribute('data-speed')) || 40;
    track.style.setProperty('--czh-shift', (-width) + 'px');
    track.style.setProperty('--czh-dur', (width / speed).toFixed(2) + 's');
    el.classList.add('is-ready');
  }

  function initMarquees(root) {
    root.querySelectorAll('[data-czh-marquee]').forEach(function (el) {
      setupMarquee(el);
      if (!el.__czhResize && 'ResizeObserver' in window) {
        var lastW = el.clientWidth;
        el.__czhResize = new ResizeObserver(debounce(function () {
          if (Math.abs(el.clientWidth - lastW) > 2) { lastW = el.clientWidth; setupMarquee(el); }
        }, 200));
        el.__czhResize.observe(el);
      }
    });
  }

  /* ------------------------------------------------------------------------
     Îlot (menu mobile) + état au défilement
     ------------------------------------------------------------------------ */
  var threshold = 0;
  var ticking = false;

  function measure() {
    var announce = document.querySelector('[data-czh-announce]');
    docEl.style.setProperty('--czh-announce-h', (announce ? announce.offsetHeight : 0) + 'px');

    var header = document.querySelector('[data-czh-header]');
    var after = document.querySelector('[data-czh-sticky-after]');
    var top = scrollTop();
    if (after && document.querySelector('[data-czh-sticky-bar]')) {
      /* Page produit : la barre apparaît une fois le bouton « Ajouter au panier » dépassé */
      threshold = after.getBoundingClientRect().bottom + top;
      if (header) header.style.setProperty('--czh-header-h', header.offsetHeight + 'px');
    } else if (header) {
      var wasFixed = header.classList.contains('is-fixed');
      if (wasFixed) header.classList.remove('is-fixed');
      var rect = header.getBoundingClientRect();
      threshold = rect.bottom + top;
      header.style.setProperty('--czh-header-h', header.offsetHeight + 'px');
      if (wasFixed) header.classList.add('is-fixed');
    } else {
      threshold = (announce ? announce.offsetHeight : 0) + 90;
    }
    update();
  }

  function update() {
    ticking = false;
    var y = scrollTop();
    var bar = document.querySelector('[data-czh-sticky-bar]');
    var header = document.querySelector('[data-czh-header]');
    var past = y > threshold - 6;

    docEl.classList.toggle('czh-scrolled', past && !!bar);

    if (header) {
      var canFix = header.getAttribute('data-sticky') === 'true' && !bar;
      header.classList.toggle('is-fixed', canFix && past);
      if (past && bar && header.classList.contains('is-open')) closeMenu(header);
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  function closeMenu(header) {
    var btn = header.querySelector('[data-czh-menu-toggle]');
    var panel = header.querySelector('[data-czh-panel]');
    header.classList.remove('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.inert = true;
  }

  function openMenu(header) {
    var btn = header.querySelector('[data-czh-menu-toggle]');
    var panel = header.querySelector('[data-czh-panel]');
    header.classList.add('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) {
      panel.inert = false;
      var first = panel.querySelector('a, button');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 120);
    }
  }

  function initHeader(root) {
    root.querySelectorAll('[data-czh-header]').forEach(function (header) {
      if (header.__czhReady) return;
      header.__czhReady = true;
      var btn = header.querySelector('[data-czh-menu-toggle]');
      var island = header.querySelector('[data-czh-island]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (header.classList.contains('is-open')) closeMenu(header); else openMenu(header);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.classList.contains('is-open')) { closeMenu(header); btn.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (header.classList.contains('is-open') && island && !island.contains(e.target)) closeMenu(header);
      });
      header.querySelectorAll('[data-czh-panel] a').forEach(function (a) {
        a.addEventListener('click', function () { closeMenu(header); });
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
        if (mq.matches) closeMenu(header);
      });
    });
  }

  /* ------------------------------------------------------------------------
     Arches : pastilles de couleur
     ------------------------------------------------------------------------ */
  function selectColor(arch, swatch, focus) {
    var index = swatch.getAttribute('data-czh-color');
    arch.querySelectorAll('[data-czh-color]').forEach(function (s) {
      var on = s === swatch;
      s.setAttribute('aria-checked', on ? 'true' : 'false');
      s.setAttribute('tabindex', on ? '0' : '-1');
    });
    arch.querySelectorAll('[data-czh-color-img]').forEach(function (img) {
      img.classList.toggle('is-active', img.getAttribute('data-czh-color-img') === index);
    });
    var archColor = swatch.getAttribute('data-arch');
    if (archColor) arch.style.setProperty('--czh-arch-bg', archColor);
    var url = swatch.getAttribute('data-url');
    if (url) arch.querySelectorAll('[data-czh-arch-link]').forEach(function (a) { a.setAttribute('href', url); });
    var label = arch.querySelector('[data-czh-color-label]');
    if (label) label.textContent = swatch.getAttribute('data-name') || '';
    if (focus) swatch.focus();
  }

  function initArches(root) {
    root.querySelectorAll('[data-czh-arch]').forEach(function (arch) {
      if (arch.__czhReady) return;
      arch.__czhReady = true;
      var swatches = Array.prototype.slice.call(arch.querySelectorAll('[data-czh-color]'));
      swatches.forEach(function (sw, i) {
        sw.addEventListener('click', function () { selectColor(arch, sw, false); });
        sw.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) selectColor(arch, sw, false);
        });
        sw.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = swatches[(i + 1) % swatches.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = swatches[(i - 1 + swatches.length) % swatches.length];
          if (next) { e.preventDefault(); selectColor(arch, next, true); }
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Vidéos : lecture quand visibles, bouton pause (accessibilité)
     ------------------------------------------------------------------------ */
  function initVideos(root) {
    root.querySelectorAll('[data-czh-video]').forEach(function (box) {
      if (box.__czhReady) return;
      var video = box.querySelector('video');
      if (!video) return;
      box.__czhReady = true;
      var btn = box.querySelector('[data-czh-video-toggle]');
      var userPaused = reduceMotion.matches;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');

      function sync() {
        box.classList.toggle('is-paused', video.paused);
        if (btn) btn.setAttribute('aria-label', video.paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);

      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) { userPaused = false; video.play().catch(function () {}); }
          else { userPaused = true; video.pause(); }
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !userPaused) video.play().catch(function () {});
            else if (!entry.isIntersecting && !video.paused) video.pause();
          });
        }, { threshold: 0.35 }).observe(box);
      } else if (!userPaused) {
        video.play().catch(function () {});
      }
      sync();
    });

    /* Vidéo du hero : respecte « réduire les animations » */
    root.querySelectorAll('[data-czh-hero-video] video').forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      if (reduceMotion.matches) { video.removeAttribute('autoplay'); video.pause(); }
      else video.play().catch(function () {});
    });
  }

  /* ------------------------------------------------------------------------
     Apparitions douces au défilement
     ------------------------------------------------------------------------ */
  var revealObserver = null;
  function initReveal(root) {
    if (designMode || reduceMotion.matches || !('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    var items = root.querySelectorAll('.czh-arch, .czh-mode, .czh-step, .czh-unbox__copy, .czh-unbox__media, .czh-arches__head, .czh-modes__head');
    items.forEach(function (el, i) {
      if (el.classList.contains('czh-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) return; /* déjà visible : pas d'animation */
      el.classList.add('czh-reveal');
      el.style.transitionDelay = ((i % 3) * 0.08) + 's';
      revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     FAQ Section Store : onglets et questions utilisables au clavier
     (Entrée / Espace) et annoncés aux lecteurs d'écran.
     ------------------------------------------------------------------------ */
  function watchClass(el, target, attr) {
    function sync() { el.setAttribute(attr, target.classList.contains('active') ? 'true' : 'false'); }
    sync();
    if ('MutationObserver' in window) new MutationObserver(sync).observe(target, { attributes: true, attributeFilter: ['class'] });
  }
  function initFaq(root) {
    var nodes = root.querySelectorAll('[class*="faq-toggle-"], [class*="faq-tab-toggle-"]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.__czhFaq) return;
      el.__czhFaq = true;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (/faq-tab-toggle-/.test(el.className)) {
        if (el.parentElement) watchClass(el, el.parentElement, 'aria-expanded');
      } else {
        watchClass(el, el, 'aria-pressed');
      }
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        el.click();
      });
    });
  }

  /* ------------------------------------------------------------------------
     Initialisation
     ------------------------------------------------------------------------ */
  function init(root) {
    root = root || document;
    initMarquees(root);
    initHeader(root);
    initArches(root);
    initVideos(root);
    initReveal(root);
    initFaq(root);
    measure();
  }

  function boot() {
    init(document);
    window.addEventListener('scroll', onScroll, { passive: true });
    var pw = pageWrapper();
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounce(measure, 150));
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document.querySelectorAll('[data-czh-marquee]').forEach(setupMarquee);
        measure();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Lien « Retour en haut » */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-czh-to-top]');
    if (!link) return;
    e.preventDefault();
    var behavior = reduceMotion.matches ? 'auto' : 'smooth';
    var pw = pageWrapper();
    if (pw) pw.scrollTo({ top: 0, behavior: behavior });
    window.scrollTo({ top: 0, behavior: behavior });
    var target = document.querySelector('#MainContent');
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  });

  /* Éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(measure, 50); });
  document.addEventListener('shopify:section:select', function (e) {
    var bar = e.target.querySelector('[data-czh-sticky-bar]');
    if (bar) bar.classList.add('is-forced');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var bar = e.target.querySelector('[data-czh-sticky-bar]');
    if (bar) bar.classList.remove('is-forced');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var header = e.target.closest && e.target.closest('[data-czh-header]');
    if (header && window.innerWidth < 990) openMenu(header);
    var marquee = e.target.closest && e.target.closest('[data-czh-marquee]');
    if (marquee) marquee.classList.add('is-paused');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var marquee = e.target.closest && e.target.closest('[data-czh-marquee]');
    if (marquee) marquee.classList.remove('is-paused');
  });
})();
